export const translations = {
  en: {
    heroTitle: "Companies in",
    heroSubtitle: "Discover tech opportunities on the French Riviera (PACA region).",
    searchPlaceholder: "Search for jobs, companies, or skills...",
    searchButton: "Search",
    ctaBrowse: "Browse All Jobs",
    ctaUpload: "Upload CV & Get Matches",
    ctaExpat: "Expat Guide",
    stats: {
      activeJobs: "Active Jobs",
      companies: "Companies",
      successStories: "Success Stories",
      blogArticles: "Blog Articles"
    },
    //... add all keys, including featured/benefits
  },
  fr: {
    heroTitle: "Les entreprises in",
    heroSubtitle: "Découvrez les opportunités tech sur la Côte d'Azur (région PACA).",
    searchPlaceholder: "Rechercher des emplois, des entreprises ou des compétences...",
    searchButton: "Rechercher",
    ctaBrowse: "Voir tous les emplois",
    ctaUpload: "Téléchargez votre CV & Obtenez des correspondances",
    ctaExpat: "Guide Expat",
    stats: {
      activeJobs: "Emplois actifs",
      companies: "Entreprises",
      successStories: "Histoires de succès",
      blogArticles: "Articles de blog"
    },
    //... translate the rest
  }
};
